export enum SubscriptionTypeEnum {
  bee_plugin = 'bee_plugin'
}
